module.exports = __webpack_public_path__ + "static/media/dmg.a758b95a.jpg";